import { NavLink } from 'react-router';

interface RouteNavigationLink {
  end?: boolean;
  label: string;
  to: string;
}

interface RouteNavigationProps {
  ariaLabel: string;
  links: RouteNavigationLink[];
}

export const RouteNavigation = ({ ariaLabel, links }: RouteNavigationProps) => (
  <nav aria-label={ariaLabel} className="slds-p-around_small slds-border_bottom">
    <ul className="slds-button-group slds-wrap">
      {links.map(({ end, label, to }) => (
        <li key={to}>
          <NavLink
            className={({ isActive }) => `slds-button slds-button_neutral${isActive ? ' slds-button_brand' : ''}`}
            end={end}
            to={to}
          >
            {label}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);
